import { ClassificationRules } from '../modules/accounting/index.js';
import type { ClassificationRulesView } from './list-views.js';
import type { ViewSetter } from './view-state.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';

export function CompanyClassificationRulesScreen({
  view,
  onView,
}: {
  view: ClassificationRulesView;
  onView: ViewSetter<ClassificationRulesView>;
}) {
  const { can } = useCompanyScope();
  return (
    <GatedCompanyScreen allowed={can('accounting.rules.manage')}>
      <ClassificationRules view={view} onView={onView} />
    </GatedCompanyScreen>
  );
}
